module.exports = __webpack_public_path__ + "img/information_message_of_love@2x.9e18f00.jpg";